import {ILevelsRepository} from './ILevelsRepository';
import {Amplify} from 'aws-amplify';
import {
  InitWithAmplify,
  InitEnvironmentVariable,
  LevelService as PikadoLevelService,
  CreateNewLevelInput,
  UpdateNewLevelInput,
} from '@PikaDoApp/npm-pikado-logic';
import {getEnvironment} from '../../lib/getEnvironment';
import {LevelUI} from './LevelTypes';

// Initialize the Pikado Logic package
InitWithAmplify(Amplify);
InitEnvironmentVariable(getEnvironment());

const pikadoLevelService = new PikadoLevelService();

export class LevelsRepository implements ILevelsRepository {
  async getLevels(): Promise<Array<LevelUI>> {
    try {
      const levels = await pikadoLevelService.getNewLevels();

      if (!levels) {
        return [];
      }

      // Map _id to id for UI compatibility
      return levels.map(level => ({
        ...level,
        id: level._id,
      }));
    } catch (error) {
      console.error(
        '🔍 [LEVEL-NEW-PACKAGE] getLevels repository Error:',
        error,
      );
      throw error;
    }
  }

  // async getNewLevels(): Promise<Array<LevelUI>> {
  //   try {
  //     const levels = await pikadoLevelService.getNewLevels();

  //     if (!levels) {
  //       return [];
  //     }

  //     // Map _id to id for UI compatibility
  //     return levels.map(level => ({
  //       ...level,
  //       id: level._id,
  //     }));
  //   } catch (error) {
  //     console.error(
  //       '🔍 [LEVEL-NEW-PACKAGE] getNewLevels repository Error:',
  //       error,
  //     );
  //     throw error;
  //   }
  // }

  async getNewLevelById(id: string): Promise<LevelUI | null> {
    try {
      const level = await pikadoLevelService.getNewLevelById(id);

      if (!level) {
        return null;
      }

      // Map _id to id for UI compatibility
      return {
        ...level,
        id: level._id,
      };
    } catch (error) {
      console.error(
        '🔍 [LEVEL-NEW-PACKAGE] getNewLevelById repository Error:',
        error,
      );
      throw error;
    }
  }

  async createNewLevel(input: CreateNewLevelInput): Promise<LevelUI | null> {
    try {
      const createdLevel = await pikadoLevelService.createNewLevel(input);

      if (!createdLevel) {
        return null;
      }

      // Map _id to id for UI compatibility
      return {
        ...createdLevel,
        id: createdLevel._id,
      };
    } catch (error) {
      console.error(
        '🔍 [LEVEL-NEW-PACKAGE] createNewLevel repository Error:',
        error,
      );
      throw error;
    }
  }

  async updateNewLevel(input: UpdateNewLevelInput): Promise<LevelUI | null> {
    try {
      const updatedLevel = await pikadoLevelService.updateNewLevel(input);

      if (!updatedLevel) {
        return null;
      }

      // Map _id to id for UI compatibility
      return {
        ...updatedLevel,
        id: updatedLevel._id,
      };
    } catch (error) {
      console.error(
        '🔍 [LEVEL-NEW-PACKAGE] updateNewLevel repository Error:',
        error,
      );
      throw error;
    }
  }

  async deleteNewLevel(id: string): Promise<any> {
    try {
      const result = await pikadoLevelService.softDeleteNewLevel(id);
      return result;
    } catch (error) {
      console.error(
        '🔍 [LEVEL-NEW-PACKAGE] deleteNewLevel repository Error:',
        error,
      );
      throw error;
    }
  }
}
